"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.from");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
var _menuStoreTemplate = require("@/api/goods/menuStoreTemplate");
var _goods = require("@/api/goods/goods");
var _dishGroup = require("@/api/goods/dishGroup");
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _auth = require("@/utils/auth");
var _scheduledShelfTask = require("@/api/goods/scheduledShelfTask");
var _asyncTask = require("@/api/job/asyncTask");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'goodsListing',
  data: function data() {
    return {
      activeName: 'productListingAndRemoval',
      storeSearch: '',
      submitting: false,
      selectedStoreCount: 0,
      addDialogVisible: false,
      productSearch: '',
      selectedProducts: [],
      menuTypeList: [],
      selectedTableProducts: [],
      importDialogVisible: false,
      importing: false,
      importForm: {
        operation: 'check'
      },
      form: {
        operation: '',
        scance: [],
        stores: []
      },
      rules: {
        operation: [{
          required: true,
          message: '请选择操作类型',
          trigger: 'change'
        }]
      },
      // 苹果风格的模拟数据
      tableData: [],
      // 可选商品列表（用于弹框选择）
      availableProducts: [],
      filteredProductList: [],
      treeData: [],
      // 定时任务相关
      scheduleDialogVisible: false,
      scheduleSubmitting: false,
      scheduleForm: {
        scheduledTime: '',
        operation: '',
        scene: [],
        stores: [],
        goodsIds: [],
        taskName: ''
      },
      scheduleRules: {
        scheduledTime: [{
          required: true,
          message: '请选择执行时间',
          trigger: 'change'
        }],
        taskName: [{
          required: true,
          message: '请输入任务名称',
          trigger: 'blur'
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // 禁用过去的时间
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 定时任务管理弹窗
      taskManageDialogVisible: false,
      taskList: [],
      taskLoading: false,
      taskPagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      // 商品信息缓存
      goodsInfoCache: {},
      // 商品上下架批量导入
      goodsShelfImportDialogVisible: false,
      goodsShelfImporting: false,
      goodsShelfImportForm: {},
      // 商品上下架批量导入异步任务
      goodsShelfTaskVisible: false,
      goodsShelfTaskId: null,
      goodsShelfTaskStatus: '',
      goodsShelfTaskProgress: 0,
      goodsShelfTaskCurrent: 0,
      goodsShelfTaskTotal: 0,
      goodsShelfTaskError: '',
      goodsShelfTaskTimer: null,
      // 商品分类
      categories: [],
      productCategories: [],
      // 适用区域及分类
      regionCategory: '',
      // 关联商品列表弹窗
      relatedGoodsDialogVisible: false,
      relatedGoodsList: [],
      relatedGoodsLoading: false,
      // 门店信息缓存
      storeInfoCache: {},
      // 关联门店列表弹窗
      relatedStoresDialogVisible: false,
      relatedStoresList: [],
      relatedStoresLoading: false
    };
  },
  computed: {
    headerCellStyle: function headerCellStyle() {
      return {
        background: '#F5F5F7',
        color: '#1D1D1F',
        fontWeight: 600,
        fontSize: '13px',
        borderBottom: '1px solid #E5E5E7'
      };
    },
    uploadHeaders: function uploadHeaders() {
      return {
        "X-Token": (0, _auth.getToken)()
      };
    },
    uploadUrl: function uploadUrl() {
      return process.env.VUE_APP_PIM_API + 'xyMenuStoreTemplate/importExcel';
    },
    goodsShelfUploadUrl: function goodsShelfUploadUrl() {
      return process.env.VUE_APP_PIM_API + 'xyMenuStoreTemplate/importGoodsShelfExcel';
    },
    // 商品上下架导入任务进度条状态（el-progress 的 status）
    goodsShelfProgressStatus: function goodsShelfProgressStatus() {
      if (this.goodsShelfTaskStatus === 'completed') {
        return 'success';
      }
      if (this.goodsShelfTaskStatus === 'failed') {
        return 'exception';
      }
      return undefined;
    }
  },
  watch: {
    storeSearch: function storeSearch(val) {
      var _this = this;
      if (this.$refs.treeRef) {
        this.$refs.treeRef.filter(val ? val.trim() : '');
        if (!val || !val.trim()) {
          this.$nextTick(function () {
            _this.collapseAllTreeNodes();
          });
        }
      }
    }
  },
  mounted: function mounted() {
    this.getStoreList();
    this.getMenuType();
    this.getCategoryTree();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopPollingGoodsShelfTaskProgress();
  },
  methods: {
    getMenuType: function getMenuType() {
      var _this2 = this;
      (0, _goods_activity_combo.queryMenuType)().then(function (res) {
        if (res.code == 200) {
          _this2.menuTypeList = res.data.records || [];
        }
      });
    },
    // 获取商品分类树
    getCategoryTree: function getCategoryTree() {
      var _this3 = this;
      (0, _goods.getCategoryTree)().then(function (res) {
        if (res && res.data) {
          _this3.categories = res.data;
        }
      });
    },
    getStoreList: function getStoreList() {
      var _this4 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        if (res.code == 200) {
          // 将 storeRegions 转为 el-tree 所需格式
          var regions = res.data.storeRegions || [];
          var storeCache = {};
          _this4.treeData = regions.map(function (region) {
            return {
              id: "region_".concat(region.regionId),
              label: region.regionName,
              isRegion: true,
              storeCount: region.storeList ? region.storeList.length : 0,
              children: (region.storeList || []).map(function (store) {
                storeCache[store.storeId] = {
                  storeId: store.storeId,
                  storeName: store.storeName,
                  regionId: region.regionId,
                  regionName: region.regionName,
                  storeAddress: store.storeAddress || ''
                };
                return {
                  id: store.storeId,
                  label: store.storeName,
                  isRegion: false
                };
              })
            };
          });
          _this4.storeInfoCache = Object.assign({}, _this4.storeInfoCache, storeCache);
          _this4.$nextTick(function () {
            _this4.initDefaultSelection();
          });
        }
      });
    },
    // 门店选择变化
    handleCheck: function handleCheck() {
      var _this5 = this;
      this.$nextTick(function () {
        var checkedNodes = _this5.$refs.treeRef.getCheckedNodes(true);
        _this5.selectedStoreCount = checkedNodes.length;
        _this5.form.stores = checkedNodes.map(function (node) {
          return node.id;
        });
      });
    },
    // 全选
    handleCheckAll: function handleCheckAll() {
      this.$refs.treeRef.setCheckedNodes(this.getAllLeafNodes(this.treeData));
      this.handleCheck();
    },
    // 取消全选
    handleUncheckAll: function handleUncheckAll() {
      this.$refs.treeRef.setCheckedKeys([]);
      this.handleCheck();
    },
    // 获取所有叶子节点（门店）
    getAllLeafNodes: function getAllLeafNodes(nodes) {
      var _this6 = this;
      var leafNodes = [];
      nodes.forEach(function (node) {
        if (node.children && node.children.length > 0) {
          leafNodes = leafNodes.concat(_this6.getAllLeafNodes(node.children));
        } else {
          leafNodes.push(node);
        }
      });
      return leafNodes;
    },
    // 初始化默认选择数量
    initDefaultSelection: function initDefaultSelection() {
      if (this.$refs.treeRef) {
        this.handleCheck();
      }
    },
    // 过滤树节点
    filterStoreNode: function filterStoreNode(value, data, node) {
      if (!value) return true;
      var query = value.trim().toLowerCase();
      if (!query) return true;

      // 1. 节点自身名称匹配
      if (data && data.label && data.label.toLowerCase().includes(query)) {
        return true;
      }

      // 2. 如果是门店节点（叶子节点），所属大区名称匹配也视为匹配
      if (node && node.parent && node.parent.data && node.parent.data.label) {
        if (node.parent.data.label.toLowerCase().includes(query)) {
          return true;
        }
      }

      // 3. 如果是大区节点，其子门店中有任意一个匹配，则该大区保留展示
      if (node && node.childNodes && node.childNodes.length > 0) {
        return node.childNodes.some(function (child) {
          return child.data && child.data.label && child.data.label.toLowerCase().includes(query);
        });
      }
      return false;
    },
    // 收起所有树节点
    collapseAllTreeNodes: function collapseAllTreeNodes() {
      if (!this.$refs.treeRef) return;
      var root = this.$refs.treeRef.root;
      if (root && root.childNodes) {
        root.childNodes.forEach(function (node) {
          node.expanded = false;
        });
      }
    },
    handleRemove: function handleRemove(row) {
      var _this7 = this;
      this.$confirm("\u786E\u5B9A\u8981\u79FB\u9664\u5546\u54C1 \"".concat(row.goodsName, "\" \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var index = _this7.tableData.findIndex(function (item) {
          return item.id === row.id;
        });
        if (index > -1) {
          _this7.tableData.splice(index, 1);
        }
        _this7.$message.success('移除成功');
      }).catch(function () {});
    },
    handleSubmit: function handleSubmit() {
      var _this8 = this;
      if (this.selectedStoreCount === 0) {
        this.$message.warning('请选择门店');
        return;
      }
      if (this.form.operation == '') {
        this.$message.warning('请选择操作类型');
        return;
      }
      if (!this.form.scance || this.form.scance.length === 0) {
        this.$message.warning('请选择场景');
        return;
      }
      if (this.tableData.length == 0) {
        this.$message.warning('请选择菜品');
        return;
      }
      this.submitting = true;
      var params = {
        operation: this.form.operation,
        scene: this.form.scance,
        stores: this.form.stores,
        goodsId: this.tableData.map(function (item) {
          return item.id;
        })
      };
      console.log(params);
      (0, _menuStoreTemplate.updXyMenuStoreTemplate)(params).then(function (res) {
        if (res.code == 0 || res.code == 200) {
          _this8.$message.success('保存成功');
        }
      }).catch(function (err) {
        _this8.$message.error(err.message);
      }).finally(function () {
        _this8.submitting = false;
      });
    },
    handleCancel: function handleCancel() {
      this.$refs.formRef.resetFields();
      this.handleClearSelection();
    },
    // 打开添加商品弹框
    handleOpenAddDialog: function handleOpenAddDialog() {
      var _this9 = this;
      this.addDialogVisible = true;
      this.productSearch = '';
      this.productCategories = [];
      this.regionCategory = '';
      this.filteredProductList = (0, _toConsumableArray2.default)(this.availableProducts);
      this.$nextTick(function () {
        _this9.setExistingSelection();
      });
    },
    // 关闭添加商品弹框
    handleCloseAddDialog: function handleCloseAddDialog() {
      this.addDialogVisible = false;
      this.productSearch = '';
      this.productCategories = [];
      this.regionCategory = '';
      this.selectedProducts = [];
    },
    // 默认选中已存在于 tableData 的商品
    setExistingSelection: function setExistingSelection() {
      var _this0 = this;
      if (!this.$refs.productTableRef) return;
      this.$refs.productTableRef.clearSelection();
      var existingIds = new Set(this.tableData.map(function (item) {
        return item.id;
      }));
      this.filteredProductList.forEach(function (row) {
        if (existingIds.has(row.id)) {
          _this0.$refs.productTableRef.toggleRowSelection(row, true);
        }
      });
    },
    // 商品搜索
    handleProductSearch: function () {
      var _handleProductSearch = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this1 = this;
        var groupParams, groupRes, groups, groupIds, itemPromises, allItems, goodsIds, goodsParams, goodsRes, params, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.productSearch && (!this.productCategories || this.productCategories.length === 0) && !this.regionCategory)) {
                _context.next = 1;
                break;
              }
              this.filteredProductList = (0, _toConsumableArray2.default)(this.availableProducts);
              this.$nextTick(function () {
                return _this1.setExistingSelection();
              });
              return _context.abrupt("return");
            case 1:
              if (!this.regionCategory) {
                _context.next = 10;
                break;
              }
              _context.prev = 2;
              // 第一步：查询匹配的菜品分组
              groupParams = {
                page: 1,
                limit: 100,
                regionCategory: this.regionCategory
              };
              _context.next = 3;
              return (0, _dishGroup.queryList)(groupParams);
            case 3:
              groupRes = _context.sent;
              if (!(groupRes.code !== 200 || !groupRes.data || !groupRes.data.records || groupRes.data.records.length === 0)) {
                _context.next = 4;
                break;
              }
              // 没有找到匹配的分组
              this.filteredProductList = [];
              this.$nextTick(function () {
                return _this1.setExistingSelection();
              });
              return _context.abrupt("return");
            case 4:
              // 第二步：查询这些分组中关联的商品
              groups = groupRes.data.records;
              groupIds = groups.map(function (g) {
                return g.id;
              }); // 获取所有分组的商品
              itemPromises = groupIds.map(function (groupId) {
                return (0, _dishGroup.getDishGroupItems)({
                  dishGroupId: groupId
                }).then(function (res) {
                  if (res.code === 200 && res.data) {
                    return res.data;
                  }
                  return [];
                }).catch(function () {
                  return [];
                });
              });
              _context.next = 5;
              return Promise.all(itemPromises);
            case 5:
              allItems = _context.sent;
              goodsIds = new Set();
              allItems.forEach(function (items) {
                if (Array.isArray(items)) {
                  items.forEach(function (item) {
                    if (item && item.goodsId) {
                      goodsIds.add(item.goodsId);
                    }
                  });
                }
              });

              // 如果没有商品ID，返回空结果
              if (!(goodsIds.size === 0)) {
                _context.next = 6;
                break;
              }
              this.filteredProductList = [];
              this.$nextTick(function () {
                return _this1.setExistingSelection();
              });
              return _context.abrupt("return");
            case 6:
              // 第三步：根据商品ID列表获取完整的商品信息
              goodsParams = {
                page: 1,
                limit: 1000,
                goodsIds: Array.from(goodsIds).join(',')
              }; // 添加关键词搜索
              if (this.productSearch) {
                goodsParams.keywords = this.productSearch;
              }

              // 添加分类筛选
              if (this.productCategories && this.productCategories.length > 0) {
                if (this.productCategories.length >= 1) {
                  goodsParams.categoryFirstId = this.productCategories[0];
                }
                if (this.productCategories.length >= 2) {
                  goodsParams.categorySecondId = this.productCategories[1];
                }
              }
              _context.next = 7;
              return (0, _goods.queryList)(goodsParams);
            case 7:
              goodsRes = _context.sent;
              if (goodsRes.code === 200) {
                this.filteredProductList = goodsRes.records || [];
                this.$nextTick(function () {
                  return _this1.setExistingSelection();
                });
              } else {
                this.filteredProductList = [];
                this.$nextTick(function () {
                  return _this1.setExistingSelection();
                });
              }
              _context.next = 9;
              break;
            case 8:
              _context.prev = 8;
              _t = _context["catch"](2);
              console.error('查询失败:', _t);
              this.filteredProductList = [];
              this.$nextTick(function () {
                return _this1.setExistingSelection();
              });
            case 9:
              return _context.abrupt("return");
            case 10:
              // 没有适用区域及分类筛选，直接查询商品
              params = {
                page: 1,
                limit: 100
              }; // 添加关键词搜索
              if (this.productSearch) {
                params.keywords = this.productSearch;
              }

              // 添加分类筛选
              if (this.productCategories && this.productCategories.length > 0) {
                // 如果选择了分类，将分类ID转换为 categoryFirstId 和 categorySecondId
                if (this.productCategories.length >= 1) {
                  params.categoryFirstId = this.productCategories[0];
                }
                if (this.productCategories.length >= 2) {
                  params.categorySecondId = this.productCategories[1];
                }
              }
              (0, _goods.queryList)(params).then(function (res) {
                if (res.code == 200) {
                  var searchResults = res.records || [];
                  _this1.filteredProductList = searchResults;
                  _this1.$nextTick(function () {
                    return _this1.setExistingSelection();
                  });
                }
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 8]]);
      }));
      function handleProductSearch() {
        return _handleProductSearch.apply(this, arguments);
      }
      return handleProductSearch;
    }(),
    // 选择商品变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedProducts = selection;
    },
    // 确认添加商品
    handleConfirmAdd: function handleConfirmAdd() {
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请至少选择一件商品');
        return;
      }
      // 过滤掉已存在的商品
      var existingIds = this.tableData.map(function (item) {
        return item.id;
      });
      var newProducts = this.selectedProducts.filter(function (product) {
        return !existingIds.includes(product.id);
      });
      var duplicateCount = this.selectedProducts.length - newProducts.length;
      if (newProducts.length > 0) {
        var _this$tableData;
        (_this$tableData = this.tableData).push.apply(_this$tableData, (0, _toConsumableArray2.default)(newProducts));
      }

      // if (duplicateCount > 0) {
      //   this.$message.warning(`${duplicateCount} 件商品已在列表中，已自动跳过`)
      // }

      if (newProducts.length > 0) {
        this.$message.success("\u6210\u529F\u6DFB\u52A0 ".concat(newProducts.length, " \u4EF6\u5546\u54C1"));
      }
      this.addDialogVisible = false;
    },
    // 商品列表选择变化
    handleTableSelectionChange: function handleTableSelectionChange(selection) {
      this.selectedTableProducts = selection;
    },
    // 批量删除商品
    handleBatchRemove: function handleBatchRemove() {
      var _this10 = this;
      if (this.selectedTableProducts.length === 0) {
        this.$message.warning('请至少选择一件商品');
        return;
      }
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u9009\u4E2D\u7684 ".concat(this.selectedTableProducts.length, " \u4EF6\u5546\u54C1\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var selectedIds = _this10.selectedTableProducts.map(function (item) {
          return item.id;
        });
        _this10.tableData = _this10.tableData.filter(function (item) {
          return !selectedIds.includes(item.id);
        });
        _this10.selectedTableProducts = [];
        _this10.$message.success('批量删除成功');
      }).catch(function () {});
    },
    // 打开导入弹框
    handleOpenImportDialog: function handleOpenImportDialog() {
      this.importDialogVisible = true;
      this.importForm.operation = 'check';
    },
    // 下载导入模板
    handleDownloadTemplate: function handleDownloadTemplate() {
      var _this11 = this;
      if (!this.importForm.operation) {
        this.$message.warning('请先选择操作类型');
        return;
      }
      var operation = this.importForm.operation === 'check' ? '勾选' : '反选';
      (0, _menuStoreTemplate.downloadImportTemplate)(this.importForm.operation).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "\u95E8\u5E97".concat(operation, "\u5BFC\u5165\u6A21\u677F.xlsx");
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(function (error) {
        console.error('下载失败:', error);
        _this11.$message.error('下载失败');
      });
    },
    // 确认导入
    handleConfirmImport: function handleConfirmImport() {
      if (!this.importForm.operation) {
        this.$message.warning('请选择操作类型');
        return;
      }
      var files = this.$refs.uploadRef.uploadFiles;
      if (!files || files.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.importing = true;
      this.$refs.uploadRef.submit();
    },
    // 上传成功回调
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      var _this12 = this;
      this.importing = false;
      if (response.code === 200 || response.code === 0) {
        // 处理导入结果
        var data = response.data;
        if (data && data.storeIds) {
          // 根据操作类型处理门店选择
          this.$nextTick(function () {
            if (_this12.importForm.operation === 'check') {
              // 勾选模式：勾选指定的门店
              _this12.$refs.treeRef.setCheckedKeys(data.storeIds);
            } else {
              // 反选模式：取消勾选指定的门店
              var currentKeys = _this12.$refs.treeRef.getCheckedKeys();
              var keysToUncheck = data.storeIds;
              var newKeys = currentKeys.filter(function (key) {
                return !keysToUncheck.includes(key);
              });
              _this12.$refs.treeRef.setCheckedKeys(newKeys);
            }
            // 更新选中门店数量
            _this12.handleCheck();
          });
          this.$message.success("\u5BFC\u5165\u6210\u529F\uFF0C\u5BFC\u5165".concat(data.storeIds.length, "\u4E2A\u95E8\u5E97"));
          // 成功后关闭弹窗
          this.importDialogVisible = false;
        } else if (response.msg) {
          this.$message.warning(response.msg);
        }
      } else {
        this.$message.error(response.msg || '导入失败');
      }
    },
    // 导入弹框关闭时的处理
    handleImportDialogClose: function handleImportDialogClose() {
      // 清除上传文件列表
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
      // 重置操作类型
      this.importForm.operation = 'check';
    },
    // 上传失败回调
    handleUploadError: function handleUploadError(err, file, fileList) {
      this.importing = false;
      this.$message.error('上传失败：' + err.message);
    },
    // ========== 定时任务相关方法 ==========
    // 打开定时任务弹窗
    handleOpenScheduleDialog: function handleOpenScheduleDialog() {
      // 校验参数
      if (this.selectedStoreCount === 0) {
        this.$message.warning('请选择门店');
        return;
      }
      if (this.form.operation == '') {
        this.$message.warning('请选择操作类型');
        return;
      }
      if (!this.form.scance || this.form.scance.length === 0) {
        this.$message.warning('请选择场景');
        return;
      }
      if (this.tableData.length == 0) {
        this.$message.warning('请选择菜品');
        return;
      }

      // 设置表单数据
      this.scheduleForm = {
        scheduledTime: '',
        operation: this.form.operation,
        scene: this.form.scance,
        stores: this.form.stores,
        goodsIds: this.tableData.map(function (item) {
          return item.id;
        }),
        taskName: "".concat(this.form.operation === '1' ? '上架' : '下架', "\u4EFB\u52A1-").concat(new Date().getTime())
      };
      this.scheduleDialogVisible = true;
    },
    // 确认创建定时任务
    handleConfirmSchedule: function handleConfirmSchedule() {
      var _this13 = this;
      this.$refs.scheduleFormRef.validate(function (valid) {
        if (valid) {
          _this13.scheduleSubmitting = true;
          (0, _scheduledShelfTask.createScheduledTask)(_this13.scheduleForm).then(function (res) {
            if (res.code == 0 || res.code == 200) {
              _this13.$message.success('定时任务创建成功');
              _this13.scheduleDialogVisible = false;
            }
          }).catch(function (err) {
            _this13.$message.error(err.message || '创建失败');
          }).finally(function () {
            _this13.scheduleSubmitting = false;
          });
        }
      });
    },
    // 打开定时任务管理弹窗
    handleOpenTaskManage: function handleOpenTaskManage() {
      this.taskManageDialogVisible = true;
      this.handleQueryScheduledTasks();
    },
    // 查询定时任务列表
    handleQueryScheduledTasks: function handleQueryScheduledTasks() {
      var _this14 = this;
      this.taskLoading = true;
      var params = {
        page: this.taskPagination.page,
        limit: this.taskPagination.limit
      };
      (0, _scheduledShelfTask.queryScheduledTaskPage)(params).then(function (res) {
        if (res.code == 0 || res.code == 200) {
          _this14.taskList = res.data.records || [];
          _this14.taskPagination.total = res.data.total || 0;
          // 加载关联商品信息
          _this14.loadRelatedGoodsInfo();
          // 加载关联门店信息
          _this14.loadRelatedStoresInfo();
        }
      }).catch(function (err) {
        _this14.$message.error(err.message || '查询失败');
      }).finally(function () {
        _this14.taskLoading = false;
      });
    },
    // 获取场景名称
    getSceneNames: function getSceneNames(sceneCodes) {
      var _this15 = this;
      if (!sceneCodes || sceneCodes.length === 0) return '-';
      var names = sceneCodes.map(function (code) {
        var item = _this15.menuTypeList.find(function (m) {
          return m.code === code;
        });
        return item ? item.desc : code;
      });
      return names.join(', ');
    },
    // 获取任务状态文本
    getTaskStatusText: function getTaskStatusText(status) {
      var statusMap = {
        0: '待执行',
        1: '已成功',
        2: '执行中',
        '-1': '失败'
      };
      return statusMap[status] || '未知';
    },
    // 获取任务状态类型
    getTaskStatusType: function getTaskStatusType(status) {
      var typeMap = {
        0: 'warning',
        1: 'success',
        2: 'primary',
        '-1': 'danger'
      };
      return typeMap[status] || 'info';
    },
    // 取消定时任务
    handleCancelTask: function handleCancelTask(row) {
      var _this16 = this;
      if (row.processStatus !== 0) {
        this.$message.warning('只能取消待执行的任务');
        return;
      }
      this.$confirm("\u786E\u5B9A\u8981\u53D6\u6D88\u4EFB\u52A1 \"".concat(row.taskName, "\" \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _scheduledShelfTask.cancelScheduledTask)(row.id).then(function (res) {
          if (res.code == 0 || res.code == 200) {
            _this16.$message.success('取消成功');
            _this16.handleQueryScheduledTasks();
          }
        }).catch(function (err) {
          _this16.$message.error(err.message || '取消失败');
        });
      }).catch(function () {});
    },
    // 删除定时任务
    handleDeleteTask: function handleDeleteTask(row) {
      var _this17 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u4EFB\u52A1 \"".concat(row.taskName, "\" \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _scheduledShelfTask.deleteScheduledTask)(row.id).then(function (res) {
          if (res.code == 0 || res.code == 200) {
            _this17.$message.success('删除成功');
            _this17.handleQueryScheduledTasks();
          }
        }).catch(function (err) {
          _this17.$message.error(err.message || '删除失败');
        });
      }).catch(function () {});
    },
    // 任务分页大小改变
    handleTaskSizeChange: function handleTaskSizeChange(size) {
      this.taskPagination.limit = size;
      this.handleQueryScheduledTasks();
    },
    // 任务当前页改变
    handleTaskCurrentChange: function handleTaskCurrentChange(page) {
      this.taskPagination.page = page;
      this.handleQueryScheduledTasks();
    },
    // ========== 关联商品相关方法 ==========
    // 批量加载关联商品信息
    loadRelatedGoodsInfo: function () {
      var _loadRelatedGoodsInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this18 = this;
        var allGoodsIds, params, res, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 收集所有任务的商品ID
              allGoodsIds = new Set();
              this.taskList.forEach(function (task) {
                if (task.goodsIds && Array.isArray(task.goodsIds)) {
                  task.goodsIds.forEach(function (goodsId) {
                    allGoodsIds.add(goodsId);
                  });
                }
              });
              if (!(allGoodsIds.size === 0)) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              _context2.prev = 1;
              params = {
                page: 1,
                limit: 1000,
                goodsIds: Array.from(allGoodsIds).join(',')
              };
              _context2.next = 2;
              return (0, _goods.queryList)(params);
            case 2:
              res = _context2.sent;
              if (res.code == 200 && res.records) {
                // 缓存商品信息
                res.records.forEach(function (goods) {
                  _this18.$set(_this18.goodsInfoCache, goods.id, goods);
                });
              }
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              console.error('查询商品信息失败:', _t2);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function loadRelatedGoodsInfo() {
        return _loadRelatedGoodsInfo.apply(this, arguments);
      }
      return loadRelatedGoodsInfo;
    }(),
    // 根据商品ID获取商品信息
    getGoodsById: function getGoodsById(goodsId) {
      return this.goodsInfoCache[goodsId] || null;
    },
    // 获取商品名称列表
    getGoodsNames: function getGoodsNames(goodsIds) {
      var _this19 = this;
      if (!goodsIds || goodsIds.length === 0) return '-';
      var names = goodsIds.map(function (goodsId) {
        var goods = _this19.getGoodsById(goodsId);
        return goods ? goods.goodsName : "#".concat(goodsId);
      }).filter(function (name) {
        return name;
      });
      return names.join(', ');
    },
    // ========== 商品上下架批量导入相关方法 ==========
    // 打开商品上下架导入弹窗
    handleOpenGoodsShelfImportDialog: function handleOpenGoodsShelfImportDialog() {
      this.goodsShelfImportDialogVisible = true;
    },
    // 下载商品上下架导入模板
    handleDownloadGoodsShelfTemplate: function handleDownloadGoodsShelfTemplate() {
      var _this20 = this;
      (0, _menuStoreTemplate.downloadGoodsShelfTemplate)().then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '商品上下架导入模板.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(function (error) {
        console.error('下载失败:', error);
        _this20.$message.error('下载失败');
      });
    },
    // 确认商品上下架导入
    handleConfirmGoodsShelfImport: function handleConfirmGoodsShelfImport() {
      var files = this.$refs.goodsShelfUploadRef.uploadFiles;
      if (!files || files.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.goodsShelfImporting = true;
      this.$refs.goodsShelfUploadRef.submit();
    },
    // 商品上下架上传成功回调
    handleGoodsShelfUploadSuccess: function handleGoodsShelfUploadSuccess(response, file, fileList) {
      this.goodsShelfImporting = false;
      if (response.code === 200 || response.code === 0) {
        var data = response.data;

        // 处理异步任务响应
        if (data && data.status) {
          if (data.status === 'exists_running') {
            // 已有执行中的任务
            this.$message.warning(data.message || '有任务正在执行中');
            var runningTask = data.runningTask;
            if (runningTask) {
              this.goodsShelfTaskId = runningTask.taskId;
              this.goodsShelfTaskStatus = runningTask.status || 'running';
              this.goodsShelfTaskProgress = runningTask.progress || 0;
              this.goodsShelfTaskCurrent = runningTask.current || 0;
              this.goodsShelfTaskTotal = runningTask.total || 0;
              this.goodsShelfTaskVisible = true;

              // 开始轮询任务进度
              this.startPollingGoodsShelfTaskProgress();
            }
          } else if (data.status === 'created') {
            // 任务创建成功
            this.goodsShelfTaskId = data.taskId;
            this.goodsShelfTaskStatus = 'pending';
            this.goodsShelfTaskProgress = 0;
            this.goodsShelfTaskCurrent = 0;
            this.goodsShelfTaskTotal = 0;
            this.goodsShelfTaskVisible = true;
            this.$message.success(data.message || '导入任务已创建，正在后台执行');

            // 开始轮询任务进度
            this.startPollingGoodsShelfTaskProgress();
          } else {
            this.$message.error('未知的状态：' + data.status);
          }
        } else {
          // 兼容旧版本同步处理
          var successCount = data.successCount || 0;
          var failCount = data.failCount || 0;
          var message = "\u5BFC\u5165\u5B8C\u6210\uFF01\u6210\u529F ".concat(successCount, " \u6761");
          if (failCount > 0) {
            message += "\uFF0C\u5931\u8D25 ".concat(failCount, " \u6761");
          }
          this.$message.success(message);

          // 如果有错误信息，显示详细错误
          if (response.msg && response.msg.includes('错误详情')) {
            this.$alert(response.msg, '导入结果', {
              confirmButtonText: '确定',
              type: failCount > 0 ? 'warning' : 'success'
            });
          }

          // 成功后关闭弹窗
          this.goodsShelfImportDialogVisible = false;
        }
      } else {
        this.$message.error(response.msg || '导入失败');
      }
    },
    // 商品上下架上传失败回调
    handleGoodsShelfUploadError: function handleGoodsShelfUploadError(err, file, fileList) {
      this.goodsShelfImporting = false;
      console.error('商品上下架上传失败：', err);
      // 不显示错误提示框，错误会在任务进度区域显示
    },
    // 商品上下架导入弹框关闭时的处理
    handleGoodsShelfImportDialogClose: function handleGoodsShelfImportDialogClose() {
      // 清除上传文件列表
      if (this.$refs.goodsShelfUploadRef) {
        this.$refs.goodsShelfUploadRef.clearFiles();
      }

      // 清除任务轮询定时器
      if (this.goodsShelfTaskTimer) {
        clearInterval(this.goodsShelfTaskTimer);
        this.goodsShelfTaskTimer = null;
      }

      // 重置任务状态
      this.goodsShelfTaskVisible = false;
      this.goodsShelfTaskId = null;
      this.goodsShelfTaskStatus = '';
      this.goodsShelfTaskProgress = 0;
      this.goodsShelfTaskCurrent = 0;
      this.goodsShelfTaskTotal = 0;
      this.goodsShelfTaskError = '';
      this.goodsShelfImporting = false;
    },
    // 开始轮询商品上下架导入任务进度
    startPollingGoodsShelfTaskProgress: function startPollingGoodsShelfTaskProgress() {
      var _this21 = this;
      if (this.goodsShelfTaskTimer) {
        clearInterval(this.goodsShelfTaskTimer);
      }

      // 立即查询一次
      this.pollGoodsShelfTaskProgress();

      // 每2秒查询一次
      this.goodsShelfTaskTimer = setInterval(function () {
        _this21.pollGoodsShelfTaskProgress();
      }, 2000);
    },
    // 轮询商品上下架导入任务进度
    pollGoodsShelfTaskProgress: function pollGoodsShelfTaskProgress() {
      var _this22 = this;
      if (!this.goodsShelfTaskId) {
        return;
      }

      // 调用任务进度查询接口
      (0, _asyncTask.getTaskProgress)(this.goodsShelfTaskId).then(function (response) {
        if (response && (response.code === 200 || response.code === 0)) {
          var progress = response.data;
          if (!progress) return;
          _this22.goodsShelfTaskStatus = progress.status;
          _this22.goodsShelfTaskProgress = progress.progress || 0;
          _this22.goodsShelfTaskCurrent = progress.current || 0;
          _this22.goodsShelfTaskTotal = progress.total || 0;

          // 如果任务完成或失败，停止轮询
          if (progress.status === 'completed') {
            _this22.stopPollingGoodsShelfTaskProgress();
            _this22.$message.success("\u5BFC\u5165\u5B8C\u6210\uFF01\u5171\u5904\u7406 ".concat(_this22.goodsShelfTaskTotal, " \u6761\u6570\u636E"));

            // 3秒后关闭弹窗
            setTimeout(function () {
              _this22.goodsShelfImportDialogVisible = false;
            }, 3000);
          } else if (progress.status === 'failed') {
            _this22.stopPollingGoodsShelfTaskProgress();
            _this22.goodsShelfTaskError = progress.errorMessage || '导入失败';
            // 不显示错误提示框，只在任务进度区域显示失败状态
          } else if (progress.status === 'cancelled') {
            _this22.stopPollingGoodsShelfTaskProgress();
            _this22.goodsShelfTaskError = '任务已被取消';
          }
        }
      }).catch(function (error) {
        console.error('查询任务进度失败:', error);
      });
    },
    // 停止轮询商品上下架导入任务进度
    stopPollingGoodsShelfTaskProgress: function stopPollingGoodsShelfTaskProgress() {
      if (this.goodsShelfTaskTimer) {
        clearInterval(this.goodsShelfTaskTimer);
        this.goodsShelfTaskTimer = null;
      }
    },
    // ========== 关联商品列表相关方法 ==========
    // 查看关联商品列表
    handleViewRelatedGoods: function handleViewRelatedGoods(task) {
      var _this23 = this;
      if (!task.goodsIds || task.goodsIds.length === 0) {
        this.$message.warning('暂无关联商品');
        return;
      }
      this.relatedGoodsDialogVisible = true;
      this.relatedGoodsLoading = true;
      this.relatedGoodsList = [];

      // 从缓存中获取商品信息
      var goodsList = [];
      task.goodsIds.forEach(function (goodsId) {
        var goods = _this23.getGoodsById(goodsId);
        if (goods) {
          goodsList.push(goods);
        }
      });
      this.relatedGoodsList = goodsList;
      this.relatedGoodsLoading = false;
    },
    // ========== 关联门店列表相关方法 ==========
    // 批量加载关联门店信息
    loadRelatedStoresInfo: function () {
      var _loadRelatedStoresInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, regions, storeCache, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(Object.keys(this.storeInfoCache).length > 0)) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              _context3.prev = 1;
              _context3.next = 2;
              return (0, _goods_activity_combo.queryRegionStoreList)();
            case 2:
              res = _context3.sent;
              if (res.code === 200 && res.data) {
                regions = res.data.storeRegions || [];
                storeCache = {};
                regions.forEach(function (region) {
                  (region.storeList || []).forEach(function (store) {
                    storeCache[store.storeId] = {
                      storeId: store.storeId,
                      storeName: store.storeName,
                      regionId: region.regionId,
                      regionName: region.regionName,
                      storeAddress: store.storeAddress || ''
                    };
                  });
                });
                this.storeInfoCache = Object.assign({}, this.storeInfoCache, storeCache);
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              console.error('查询门店信息失败:', _t3);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function loadRelatedStoresInfo() {
        return _loadRelatedStoresInfo.apply(this, arguments);
      }
      return loadRelatedStoresInfo;
    }(),
    // 根据门店ID获取门店信息
    getStoreById: function getStoreById(storeId) {
      return this.storeInfoCache[storeId] || this.storeInfoCache[String(storeId)] || null;
    },
    // 查看关联门店列表
    handleViewRelatedStores: function () {
      var _handleViewRelatedStores = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(task) {
        var _this24 = this;
        var storeList;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!task.stores || task.stores.length === 0)) {
                _context4.next = 1;
                break;
              }
              this.$message.warning('暂无关联门店');
              return _context4.abrupt("return");
            case 1:
              this.relatedStoresDialogVisible = true;
              this.relatedStoresLoading = true;
              this.relatedStoresList = [];

              // 若尚未加载门店信息，则先加载
              if (!(Object.keys(this.storeInfoCache).length === 0)) {
                _context4.next = 2;
                break;
              }
              _context4.next = 2;
              return this.loadRelatedStoresInfo();
            case 2:
              // 从缓存中获取门店信息
              storeList = [];
              task.stores.forEach(function (storeId) {
                var store = _this24.getStoreById(storeId);
                if (store) {
                  storeList.push(store);
                } else {
                  storeList.push({
                    storeId: storeId,
                    storeName: "\u95E8\u5E97 #".concat(storeId),
                    regionName: '-',
                    storeAddress: '-'
                  });
                }
              });
              this.relatedStoresList = storeList;
              this.relatedStoresLoading = false;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleViewRelatedStores(_x) {
        return _handleViewRelatedStores.apply(this, arguments);
      }
      return handleViewRelatedStores;
    }()
  }
};